// Get Credits translations for each language from translation.json
import translationData from "../../../../../data/translation.json";

// Language configuration
export const LANGUAGE_CONFIG = ["zh", "en", "ja", "th"] as const;
export type LanguageKey = typeof LANGUAGE_CONFIG[number];

export const getCreditsTranslation = () => {
  // Dynamically get Credits translations for each language from translation file
  return LANGUAGE_CONFIG.reduce((acc, language) => {
    acc[language] = translationData[language].translation.Credits;
    return acc;
  }, {} as Record<LanguageKey, string>);
};
